<template>
  <v-container fluid class="pa-8 grey lighten-5 min-h-screen">
    
    <!-- Header Section -->
    <v-row align="center" class="mb-6">
      <v-col cols="12" md="6">
        <div class="d-flex align-center">
          <v-avatar color="primary lighten-4" size="48" class="mr-4">
            <v-icon color="primary">mdi-warehouse</v-icon>
          </v-avatar>
          <div>
            <h1 class="text-h4 font-weight-black grey--text text--darken-4">Artículos de RAMOS</h1>
            <p class="text-subtitle-1 grey--text text--darken-1 mb-0">Catálogo de productos, referencias y códigos de barras</p>
          </div>
        </div>
      </v-col>

      <!-- Panel de Acciones de Selección y Exportar -->
      <v-col cols="12" md="6" class="text-md-right">
        <v-slide-x-reverse-transition>
          <div v-if="seleccionados.length > 0" class="d-inline-flex align-center flex-wrap">
            <v-btn
              color="success darken-1"
              large
              depressed
              class="rounded-lg font-weight-bold px-5 mr-3 mb-2 shadow-sm text-capitalize"
              @click="exportarAExcel"
            >
              <v-icon left>mdi-file-excel-outline</v-icon>
              Exportar a Excel ({{ seleccionados.length }})
            </v-btn>

            <v-btn 
              outlined 
              color="grey darken-2" 
              large 
              class="rounded-lg font-weight-bold mb-2 text-capitalize"
              @click="limpiarSeleccion"
            >
              <v-icon left small>mdi-close</v-icon>
              Limpiar
            </v-btn>
          </div>
        </v-slide-x-reverse-transition>
      </v-col>
    </v-row>

    <!-- SECCIÓN: TABLA DE ELEMENTOS SELECCIONADOS -->
    <v-expand-transition>
      <div v-if="seleccionados.length > 0" class="mb-8">
        <v-card class="rounded-xl border-selection shadow-sm overflow-hidden" flat color="white">
          <v-toolbar color="teal lighten-5" flat dense class="px-2">
            <v-icon color="teal darken-2" class="mr-2">mdi-check-decagram</v-icon>
            <v-toolbar-title class="text-subtitle-1 font-weight-bold teal--text text--darken-4">
              Artículos Seleccionados para Exportar
            </v-toolbar-title>
            <v-chip small color="teal darken-1" text-color="white" class="ml-3 font-weight-bold">
              {{ seleccionados.length }}
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn icon small color="teal darken-3" @click="mostrarTablaSeleccionados = !mostrarTablaSeleccionados">
              <v-icon>{{ mostrarTablaSeleccionados ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-toolbar>

          <v-expand-transition>
            <div v-show="mostrarTablaSeleccionados">
              <v-data-table
                :headers="headersSeleccionados"
                :items="seleccionados"
                class="tabla-seleccionados"
                :items-per-page="5"
                item-key="id"
                :footer-props="{
                  'items-per-page-options': [5, 10, 20],
                  'items-per-page-text': 'Filas:'
                }"
              >
                <template v-slot:item.id="{ item }">
                  <span class="text-caption font-weight-bold teal--text text--darken-3">#{{ item.id }}</span>
                </template>

                <template v-slot:item.default_code="{ item }">
                  <v-chip small label color="teal lighten-4" text-color="teal darken-4" class="font-weight-bold text-uppercase rounded-md">
                    {{ item.default_code || 'SIN REF' }}
                  </v-chip>
                </template>

                <template v-slot:item.name="{ item }">
                  <span class="font-weight-medium grey--text text--darken-3">{{ item.name }}</span>
                </template>

                <template v-slot:item.barcode="{ item }">
                  <div class="d-flex align-center" v-if="item.barcode">
                    <v-icon small class="mr-1 teal--text text--darken-2">mdi-barcode-scan</v-icon>
                    <span class="font-mono text-body-2 font-weight-medium grey--text text--darken-2">
                      {{ item.barcode }}
                    </span>
                  </div>
                  <span v-else class="grey--text text--lighten-1 caption font-italic">Sin código</span>
                </template>

                <template v-slot:item.quitar="{ item }">
                  <v-tooltip bottom color="error">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small v-bind="attrs" v-on="on" color="error lighten-1" @click="deseleccionarUno(item)">
                        <v-icon size="18">mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Quitar de la lista</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </div>
          </v-expand-transition>
        </v-card>
      </div>
    </v-expand-transition>

    <!-- Barra de Búsqueda -->
    <v-card class="rounded-xl mb-6 border-light shadow-sm" flat color="white">
      <v-card-text class="pa-4">
        <v-text-field
          v-model="filtroBusqueda"
          @input="onSearchInput"
          label="Buscar en el catálogo general por referencia, descripción o código de barras..."
          prepend-inner-icon="mdi-magnify"
          outlined
          flat
          hide-details
          clearable
          @click:clear="limpiarBusqueda"
          background-color="grey lighten-4"
          class="rounded-lg search-bar"
        ></v-text-field>
      </v-card-text>
    </v-card>

    <!-- Tabla Principal con Paginación en Servidor -->
    <v-card class="rounded-xl border-light shadow-sm" flat color="white">
      <v-data-table
        v-model="seleccionados"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="cargando"
        item-key="id"
        show-select
        :item-class="darClaseFila"
        class="custom-table"
        :footer-props="{
          'items-per-page-options': [10, 25, 50],
          'items-per-page-text': 'Filas por página:'
        }"
        loading-text="Consultando Odoo..."
        no-results-text="No se encontraron artículos"
        no-data-text="No hay artículos disponibles"
      >
        <!-- Slot para ID -->
        <template v-slot:item.id="{ item }">
          <span class="text-caption font-weight-bold grey--text">#{{ item.id }}</span>
        </template>

        <!-- Slot para Referencia -->
        <template v-slot:item.default_code="{ item }">
          <v-chip
            small
            label
            :color="estaSeleccionado(item) ? 'teal lighten-4' : 'primary lighten-5'"
            :text-color="estaSeleccionado(item) ? 'teal darken-4' : 'primary'"
            class="font-weight-bold text-uppercase rounded-md"
          >
            {{ item.default_code || 'SIN REF' }}
          </v-chip>
        </template>

        <!-- Slot para Nombre/Descripción -->
        <template v-slot:item.name="{ item }">
          <span :class="{'teal--text text--darken-3 font-weight-bold': estaSeleccionado(item), 'grey--text text--darken-3 font-weight-medium': !estaSeleccionado(item)}">
            {{ item.name }}
          </span>
        </template>

        <!-- Slot para Código de Barras -->
        <template v-slot:item.barcode="{ item }">
          <div class="d-flex align-center" v-if="item.barcode">
            <v-icon small class="mr-1 grey--text">mdi-barcode-scan</v-icon>
            <span class="font-mono text-body-2 font-weight-medium grey--text text--darken-2">
              {{ item.barcode }}
            </span>
          </div>
          <span v-else class="grey--text text--lighten-1 caption font-italic">Sin código</span>
        </template>

        <!-- Slot para Acción: Asignar a Armario (SOLO SI esRamos) -->
        <template v-slot:item.acciones="{ item }">
          <div class="d-flex justify-center" v-if="esRamos">
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  class="action-btn assign"
                  v-bind="attrs"
                  v-on="on"
                  @click="abrirDialogAsignar(item)"
                >
                  <v-icon size="20">mdi-locker</v-icon>
                </v-btn>
              </template>
              <span>Asignar material a armario</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Diálogo de Asignación a Armario -->
    <DialogPieza
      v-if="esRamos"
      :dialog="dialogAsignacion"
      :pieza="piezaSeleccionada"
      @update:dialog="dialogAsignacion = false"
      @asignar-armario="guardarAsignacionArmario"
    />

    <!-- Feedback visual (Snackbar) -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" rounded="pill">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">Cerrar</v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import * as XLSX from "xlsx";
import DialogPieza from "./dialogs/Piezas/DialogPieza.vue";
import { mapState } from "vuex";

export default {
  name: "AlmacenOdooPage",
  components: {
    DialogPieza,
  },
  data() {
    return {
      filtroBusqueda: "",
      cargando: false,
      items: [],
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      searchTimeout: null,

      seleccionados: [],
      mostrarTablaSeleccionados: true,

      // Control del diálogo de asignación
      dialogAsignacion: false,
      piezaSeleccionada: null,

      snackbar: {
        show: false,
        text: "",
        color: "success",
      },
    };
  },
  computed: {
    ...mapState(["esRamos", "permisos"]),

    headers() {
      const baseHeaders = [
        { text: 'ID', align: 'start', value: 'id', class: 'grey lighten-4', width: '90px' },
        { text: 'Referencia', align: 'start', value: 'default_code', class: 'grey lighten-4', width: '160px' },
        { text: 'Descripción / Nombre', align: 'start', value: 'name', class: 'grey lighten-4' },
        { text: 'Código de Barras', align: 'start', value: 'barcode', class: 'grey lighten-4', width: '180px' },
      ];

      if (this.esRamos) {
        baseHeaders.push({ 
          text: 'Asignar', 
          align: 'center', 
          value: 'acciones', 
          sortable: false,
          class: 'grey lighten-4',
          width: '90px'
        });
      }

      return baseHeaders;
    },

    headersSeleccionados() {
      return [
        { text: 'ID', align: 'start', value: 'id', class: 'teal lighten-5 teal--text text--darken-4', width: '90px' },
        { text: 'Referencia', align: 'start', value: 'default_code', class: 'teal lighten-5 teal--text text--darken-4', width: '160px' },
        { text: 'Descripción / Nombre', align: 'start', value: 'name', class: 'teal lighten-5 teal--text text--darken-4' },
        { text: 'Código de Barras', align: 'start', value: 'barcode', class: 'teal lighten-5 teal--text text--darken-4', width: '180px' },
        { text: 'Quitar', align: 'center', value: 'quitar', sortable: false, class: 'teal lighten-5 teal--text text--darken-4', width: '80px' },
      ];
    }
  },
  watch: {
    options: {
      handler() {
        this.cargarDatos();
      },
      deep: true,
    },
  },
  methods: {
    onSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.options.page = 1;
        this.cargarDatos();
      }, 400);
    },

    limpiarBusqueda() {
      this.filtroBusqueda = "";
      this.options.page = 1;
      this.cargarDatos();
    },

    darClaseFila(item) {
      return this.estaSeleccionado(item) ? 'fila-seleccionada' : '';
    },

    estaSeleccionado(item) {
      return this.seleccionados.some(sel => sel.id === item.id);
    },

    limpiarSeleccion() {
      this.seleccionados = [];
    },

    deseleccionarUno(item) {
      this.seleccionados = this.seleccionados.filter(sel => sel.id !== item.id);
    },

    exportarAExcel() {
      if (!this.seleccionados.length) return;

      // 1. Mapeamos exactamente a los encabezados de la plantilla
      // AuxCode = default_code (referencia)
      // Name = name (nombre/descripción)
      // El resto de campos se dejan vacíos ""
      const datosParaExportar = this.seleccionados.map((item) => ({
        "AuxCode": item.default_code || "",
        "Name": item.name || "",
        "Observations": "",
        "MaxStock": "",
        "MinStock": "",
        "Critic": "",
        "Individualized": "",
        "IndividualizedFamily": "",
        "NumberOfDecimals": "",
        "Units": "",
        "FamilyAuxcode": "",
        "CostCenterAuxCode": "",
        "CompanyId": "",
      }));

      // 2. Crear la hoja con los datos
      const worksheet = XLSX.utils.json_to_sheet(datosParaExportar);

      // Anchos sugeridos para que se lea ordenado al abrirlo en Excel
      worksheet["!cols"] = [
        { wch: 15 }, // AuxCode
        { wch: 40 }, // Name
        { wch: 25 }, // Observations
        { wch: 12 }, // MaxStock
        { wch: 12 }, // MinStock
        { wch: 10 }, // Critic
        { wch: 15 }, // Individualized
        { wch: 22 }, // IndividualizedFamily
        { wch: 18 }, // NumberOfDecimals
        { wch: 10 }, // Units
        { wch: 16 }, // FamilyAuxcode
        { wch: 20 }, // CostCenterAuxCode
        { wch: 12 }, // CompanyId
      ];

      // 3. Crear el libro y descargarlo
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Articulos");

      const fecha = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(workbook, `articulos_plantilla_${fecha}.xlsx`);
    },

    async cargarDatos() {
      this.cargando = true;
      try {
        const { page, itemsPerPage } = this.options;
        const res = await axios.get(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/django/portal/get_products/`,
          {
            params: {
              page: page,
              page_size: itemsPerPage,
              search: this.filtroBusqueda || ''
            }
          }
        );
        this.items = res.data.products || [];
        this.totalItems = res.data.total || 0;
      } catch (error) {
        console.error("Error cargando artículos de Odoo", error);
      } finally {
        this.cargando = false;
      }
    },

    // Abrir diálogo de asignación
    abrirDialogAsignar(item) {
      if (!this.esRamos) return;
      this.piezaSeleccionada = item;
      this.dialogAsignacion = true;
    },

    // Guardar la vinculación entre artículo y armario
    async guardarAsignacionArmario(datosAsignacion) {
      try {
        // Llama a tu endpoint de asociación (NodeJS o Django)
        await axios.post(
          `${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/articulos/sync-armario`,
          datosAsignacion
        );

        this.dialogAsignacion = false;
        this.mostrarMensaje("Material asignado al armario correctamente", "success");
      } catch (error) {
        console.error("Error al asignar material al armario:", error);
        this.mostrarMensaje("Error al asignar el material al armario", "error");
      }
    },

    mostrarMensaje(texto, color = "success") {
      this.snackbar.text = texto;
      this.snackbar.color = color;
      this.snackbar.show = true;
    }
  },
  mounted() {
    const token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/login");
      return;
    }

    const usuario = jwtDecode(token);
    const validRoles = ["partes", "user", "admin", "developer"];

    if (!validRoles.includes(usuario.rol)) {
      this.$router.push(`/${usuario.rol}`);
      return;
    }
  },
};
</script>

<style lang="scss" scoped>
.min-h-screen {
  min-height: 100vh;
}

.border-light {
  border: 1px solid #e0e0e0 !important;
}

.border-selection {
  border: 1.5px solid #80cbc4 !important;
}

.shadow-sm {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03) !important;
}

.search-bar {
  transition: all 0.3s ease;
  &.v-input--is-focused {
    transform: translateY(-2px);
  }
}

.font-mono {
  font-family: 'Courier New', Courier, monospace;
  letter-spacing: 0.5px;
}

// Estilos de la tabla de seleccionados
::v-deep .tabla-seleccionados {
  background-color: transparent !important;

  thead th {
    text-transform: uppercase;
    font-size: 0.72rem !important;
    font-weight: 700 !important;
    letter-spacing: 0.8px;
    height: 48px !important;
    border-bottom: 1px solid #b2dfdb !important;
  }

  tbody tr {
    background-color: #f7fdfc !important;
    &:hover {
      background-color: #e0f2f1 !important;
    }
    td {
      height: 52px !important;
      border-bottom: 1px solid #e0f2f1 !important;
    }
  }
}

// Estilos de la tabla general
::v-deep .custom-table {
  background-color: transparent !important;

  thead {
    background-color: #f8f9fa !important;
    
    th {
      text-transform: uppercase;
      font-size: 0.75rem !important;
      font-weight: 700 !important;
      color: #757575 !important;
      letter-spacing: 1px;
      height: 56px !important;
      border-bottom: 1px solid #e0e0e0 !important;
    }
  }

  tbody {
    tr {
      transition: background-color 0.2s ease;
      
      &:hover {
        background-color: #f0f7ff !important;
      }

      td {
        height: 64px !important;
        border-bottom: 1px solid #f0f0f0 !important;
      }

      &.fila-seleccionada {
        background-color: #e0f2f1 !important;
        border-left: 4px solid #00897b;

        &:hover {
          background-color: #b2dfdb !important;
        }

        td {
          border-bottom: 1px solid #b2dfdb !important;
        }
      }
    }
  }
}

// Botón de asignación
.action-btn {
  transition: all 0.2s ease;
  
  &.assign {
    color: #1976d2;
    &:hover {
      background-color: #e3f2fd;
      transform: scale(1.1);
    }
  }
}

.rounded-md {
  border-radius: 6px !important;
}
</style>